export default __webpack_public_path__ + "static/media/rl.38af2554.gif";